<template>
  <div data-cy="preloader" class="asPreloader" :style="style">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    color: {
      type: String,
      default: () => ''
    }
  },
  setup (props) {
    const style = computed(() => {
      const _style: Dictionary<string> = {}
      if (props.color) {
        _style.color = props.color
      }
      return _style
    })

    return {
      style
    }
  }
})
</script>

<style lang="scss" scoped>
  @import '~@web/assets/scss/vars.scss';

  $color: #2850fb;

  .asPreloader {
    display: flex;
    justify-content: space-between;
    width: 100px;
    margin: 25px auto 50px;
    color: $color;

    &.-fullpage {
      margin: 0 auto;
      height: 100vh;
      align-items: center;
    }

    @media (min-width: $bp-desktop) {
      display: flex;
      margin-left: 33px;
      margin-right: 31px;
    }

    span {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      background-color: currentColor;
      margin: 0 5px;
      opacity: 0;

      &:nth-child(1) {
        animation: opacitychange 1s ease-in-out infinite;
      }

      &:nth-child(2) {
        animation: opacitychange 1s ease-in-out 0.33s infinite;
      }

      &:nth-child(3) {
        animation: opacitychange 1s ease-in-out 0.66s infinite;
      }
    }
  }

  @keyframes opacitychange{
    0%, 100%{
      opacity: 0;
    }

    60%{
      opacity: 1;
    }
  }
</style>
